import md5 from 'blueimp-md5'

import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {
  images: []
}

const uploadImageActions = generateActions('profile/image/UPLOAD')
const sendReportActions = generateActions('profile/report/SEND')

export const uploadImage = createAction(
  API_CONST,
  (lotId, file, onUploadProgress) => ({
    file,
    method: 'POST',
    actions: uploadImageActions,
    url: `auth/info/lots/${lotId}/sendReport/upload`,
    options: { onUploadProgress }
  })
)

export const clearImges = createAction('profile/image/CLEAR')

export const sendReport = createAction(
  API_CONST,
  (lotId, message, files) => ({
    method: 'POST',
    params: { message, files },
    actions: sendReportActions,
    url: `auth/info/lots/${lotId}/sendReport`
  })
)

export default handleActions({
  [clearImges]: state => ({ ...initial }),
  [uploadImageActions[1]]: (state, { payload }) => {
    return {
    ...state,
    images: {
      ...state.images,
      ...payload.reduce((obj, item) => {
        obj[md5(item.name)] = item
        return obj
      }, {})
    }
  }}
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/profile/report.js